import _get from 'lodash/get';
import isAttributeBlackListed from './isAttributeBlackListed';
import { BASE_FIELD_PAGE, BASE_FIELD_PAGE_COLLECTION } from 'pages/Attributes/consts';

/**
 * The resulting attribute list contains fields that are:
 *  - Non object attributes, unless it's `page`
 *  - Non collection attributes unless it's
 *    - simple text collections that aren't child attributes
 *    - pageCollection
 *  - Non child attributes unless it's a direct child field to reachOutToMeFor
 */

export default (
  { _fields: fields }: any,
  remainingSourceMappings: any[],
  selectedDestinations: string[],
) => {
  const fieldsKeys = Object.keys(fields);

  const attributes = fieldsKeys.reduce((acc: any[], fieldKey: string) => {
    const attribute = { ...fields[fieldKey] };
    if (!isAttributeAllowed(attribute, Object.values(fields))) {
      return acc;
    }

    // This line of code slows down the creating of a menu list
    const isInAnotherSourceMapping = remainingSourceMappings.find(
      mapping => mapping.destination === attribute.objectKey,
    );

    if (isInAnotherSourceMapping) {
      attribute.mappedToSource = isInAnotherSourceMapping.fromSource;
    }

    // This line of code slows down the creating of a menu list
    const isAttributeSelected = selectedDestinations.some(destination => {
      return attribute.objectKey === destination;
    });

    if (isAttributeSelected) {
      attribute.alreadySelected = true;
    }

    acc.push(attribute);
    return acc;
  }, []);

  return attributes;
};

function isAttributeAllowed(attribute: any, fields: any[]) {
  const isDirectReachOutToMeForChild = (attribute: any) => {
    const reachOutToMeForField = fields.find(f => f.objectKey === 'reachOutToMeFor');
    if (!reachOutToMeForField) {
      return false;
    }

    return reachOutToMeForField.fields.includes(attribute.objectKey);
  };

  const isChildField = (attribute: any) => attribute.objectKey.includes('.');

  // Don't allow for blacklisted Attributes
  if (isAttributeBlackListed(attribute)) {
    return false;
  }

  if (isDirectReachOutToMeForChild(attribute)) {
    return true;
  }

  if (!isChildField(attribute) && _get(attribute, 'item.type') === 'text') {
    return true;
  }

  if (
    attribute.baseField === BASE_FIELD_PAGE ||
    attribute.baseField === BASE_FIELD_PAGE_COLLECTION
  ) {
    return true;
  }

  if (attribute.type === 'object' || attribute.type === 'collection') {
    return false;
  }

  if (isChildField(attribute)) {
    return false;
  }

  return true;
}
